import { Box, Card, CardContent, Typography } from "../../../../components";
import { Divider, Skeleton } from "@mui/material";

function MonitorFatCard({
  titulo,
  icone,
  loading,
  alturaSkeleton = 200,
  children,
}) {
  return (
    <Card sx={{ borderRadius: 3, border: "1px solid #f0f0f0", height: "100%" }}>
      <CardContent sx={{ p: 2 }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {titulo}
          </Typography>
          <i
            className={`ph-bold ${icone}`}
            style={{ color: "#64748b", fontSize: 20 }}
          />
        </Box>
        <Divider sx={{ mb: 2 }} />
        {loading ? (
          <Skeleton
            variant="rectangular"
            height={alturaSkeleton}
            sx={{ borderRadius: 1 }}
          />
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
}

export default MonitorFatCard;
